import { BannerItem } from "../services/bannerServices";

export const clickBanner = (banner: BannerItem) => {
  if (banner.linkType === "NULL") return;
  else if (banner.linkType === "CURRENT") {
    window.location.href = banner.linkUrl;
  } else if (banner.linkType === "NEW") {
    window.open(banner.linkUrl);
  } else {
    console.error("미지원 배너 타입");
  }
};
